import {
  getGridProps
} from "./chunk-OJGKJJOE.js";
import {
  vs
} from "./chunk-56TZPABM.js";
import {
  reset
} from "./chunk-TCD77MI5.js";
import {
  getPaddingProps
} from "./chunk-L7SHRNH5.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/layout/Box.tsx
import React2, { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import cn from "classnames";

// packages/ui-lib/src/layout/Box.css.ts
var alignItems = { end: "Box_end__1o0rmmnv", start: "Box_start__1o0rmmnw", center: "Box_center__1o0rmmnx" };
var borderRadius = { none: "Box_none__1o0rmmn1k", full: "Box_full__1o0rmmn1l", standard: "Box_standard__1o0rmmn1m", medium: "Box_medium__1o0rmmn1n" };
var coloring = { brand: "Box_brand__1o0rmmn17", app: "Box_app__1o0rmmn18", "app-interactive": "Box_app-interactive__1o0rmmn19", subtle: "Box_subtle__1o0rmmn1a", "subtle-interactive": "Box_subtle-interactive__1o0rmmn1b", ui: "Box_ui__1o0rmmn1c", "ui-active": "Box_ui-active__1o0rmmn1d", "ui-interactive": "Box_ui-interactive__1o0rmmn1e", "primary-ui-interactive": "Box_primary-ui-interactive__1o0rmmn1f", "menu-item": "Box_menu-item__1o0rmmn1g", "menu-danger": "Box_menu-danger__1o0rmmn1h", "icon-danger": "Box_icon-danger__1o0rmmn1i" };
var cursor = { pointer: "Box_pointer__1o0rmmn3", "default": "Box_default__1o0rmmn4" };
var customHeight = "Box__1o0rmmnk";
var customMinHeight = "Box__1o0rmmnm";
var customWidth = "Box__1o0rmmni";
var display = { block: "Box_block__1o0rmmn12", grid: "Box_grid__1o0rmmn13", flexRow: "Box_flexRow__1o0rmmn14", flexColumn: "Box_flexColumn__1o0rmmn15" };
var flexGrow = "Box__1o0rmmn16";
var flexShrink = { "0": "Box_0__1o0rmmn1s" };
var height = { "0": "Box_0__1o0rmmn5", full: "Box_full__1o0rmmn6", touchable: "Box_touchable__1o0rmmn7", "min-touchable": "Box_min-touchable__1o0rmmn8" };
var heightVar = "var(--_1o0rmmnj)";
var justifyContent = { center: "Box_center__1o0rmmny", start: "Box_start__1o0rmmnz", end: "Box_end__1o0rmmn10", between: "Box_between__1o0rmmn11" };
var minHeight = { "0": "Box_0__1o0rmmn9", full: "Box_full__1o0rmmna", touchable: "Box_touchable__1o0rmmnb", "min-touchable": "Box_min-touchable__1o0rmmnc" };
var minHeightVar = "var(--_1o0rmmnl)";
var minWidth = { "0": "Box_0__1o0rmmnn", full: "Box_full__1o0rmmno", touchable: "Box_touchable__1o0rmmnp", "min-touchable": "Box_min-touchable__1o0rmmnq" };
var overflowX = { hidden: "Box_hidden__1o0rmmn1q", auto: "Box_auto__1o0rmmn1r" };
var overflowY = { hidden: "Box_hidden__1o0rmmn1o", auto: "Box_auto__1o0rmmn1p" };
var position = { relative: "Box_relative__1o0rmmn0", absolute: "Box_absolute__1o0rmmn1", fixed: "Box_fixed__1o0rmmn2" };
var width = { "0": "Box_0__1o0rmmnd", full: "Box_full__1o0rmmne", touchable: "Box_touchable__1o0rmmnf", "min-touchable": "Box_min-touchable__1o0rmmng" };
var widthVar = "var(--_1o0rmmnh)";

// packages/ui-lib/src/layout/Box.tsx
function isIn(k, o) {
  return k in o;
}
var Box = forwardRef((_a, forwardedRef) => {
  var _b = _a, {
    as: component = "div",
    asChild = false,
    className,
    position: position2,
    cursor: cursor2,
    boxHeight,
    boxMinHeight,
    boxWidth,
    boxMinWidth,
    display: display2,
    alignItems: alignItems2,
    justifyContent: justifyContent2,
    flexGrow: flexGrow2,
    coloring: coloring2,
    borderRadius: borderRadius2,
    overflowX: overflowX2,
    overflowY: overflowY2,
    flexShrink: flexShrink2,
    style
  } = _b, props = __objRest(_b, [
    "as",
    "asChild",
    "className",
    "position",
    "cursor",
    "boxHeight",
    "boxMinHeight",
    "boxWidth",
    "boxMinWidth",
    "display",
    "alignItems",
    "justifyContent",
    "flexGrow",
    "coloring",
    "borderRadius",
    "overflowX",
    "overflowY",
    "flexShrink",
    "style"
  ]);
  const [paddingClass, nonPaddingProps] = getPaddingProps(props);
  const [gridClass, gridVars, restProps] = getGridProps(nonPaddingProps);
  const classes = cn(reset, paddingClass, className, {
    [flexGrow]: flexGrow2,
    [gridClass]: display2 === "grid"
  }, display2 && display[display2], position2 && position[position2], cursor2 && cursor[cursor2], boxHeight != null && isIn(boxHeight, height) && height[boxHeight], boxHeight != null && !isIn(boxHeight, height) && customHeight, boxMinHeight != null && isIn(boxMinHeight, minHeight) && minHeight[boxMinHeight], boxMinHeight != null && !isIn(boxMinHeight, minHeight) && customMinHeight, boxWidth != null && isIn(boxWidth, width) && width[boxWidth], boxWidth != null && !isIn(boxWidth, width) && customWidth, boxMinWidth != null && minWidth[boxMinWidth], alignItems2 && alignItems[alignItems2], justifyContent2 && justifyContent[justifyContent2], coloring2 && coloring[coloring2], borderRadius2 && borderRadius[borderRadius2], overflowX2 && overflowX[overflowX2], overflowY2 && overflowY[overflowY2], flexShrink2 != null && flexShrink[flexShrink2]);
  const vars = vs(style, display2 === "grid" && gridVars, boxWidth != null && !isIn(boxWidth, width) && [widthVar, boxWidth], boxHeight != null && !isIn(boxHeight, height) && [heightVar, boxHeight], boxMinHeight != null && !isIn(boxMinHeight, minHeight) && [
    minHeightVar,
    boxMinHeight
  ]);
  const Comp = asChild ? Slot : component;
  return /* @__PURE__ */ React2.createElement(Comp, __spreadProps(__spreadValues({}, restProps), {
    className: classes,
    style: vars,
    ref: forwardedRef
  }));
});
Box.displayName = "Box";
var Box_default = Box;

export {
  Box_default
};
//# sourceMappingURL=chunk-GDQZHQO7.js.map
